import type { BaseModelAttributes } from "./base";
import { Locale } from "./locale";
import { I18nLabels } from "./common";

export enum UserRole {
  ADMIN = "admin",
  USER = "user",
}

export const UserRoleLabels: I18nLabels<UserRole> = {
  [UserRole.ADMIN]: { [Locale.ZH_CN]: "管理员", [Locale.EN_US]: "Admin" },
  [UserRole.USER]: { [Locale.ZH_CN]: "用户", [Locale.EN_US]: "User" },
};

export interface IUser extends BaseModelAttributes {
  username: string;
  email: string;
  phone: string | null;
  password: string;
  name: string;
  organizationName: string | null;
  phoneVerifiedAt: Date | null;
  lastLoginAt: Date | null;
  lastActiveAt: Date | null;
  role: UserRole;
  userRoleId: string | null;
}

export interface UpdateProfileRequest {
  name: string;
  email: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface UserLoginDeviceResponse {
  id: string;
  device: string;
  browser: string;
  os: string;
  ipAddress: string | null;
  userAgent: string | null;
  lastLoginAt: string;
  loginCount: number;
}

// 认证相关类型
export enum SmsCodePurpose {
  REGISTER = "register",
  LOGIN = "login",
  RESET_PASSWORD = "reset_password",
}

export interface LoginRequest {
  account: string;
  password?: string;
  code?: string;
  captchaId?: string;
  captchaCode?: string;
  loginType: "password" | "sms";
}

export interface RegisterRequest {
  phone: string;
  code: string;
  password: string;
  name: string;
  organizationName: string;
  acceptedAgreement: boolean;
}

export interface SendSmsCodeRequest {
  phone: string;
  purpose: SmsCodePurpose;
  captchaId: string;
  captchaCode: string;
}

export interface ResetPasswordRequest {
  phone: string;
  code: string;
  newPassword: string;
}

export interface CaptchaChallengeResponse {
  captchaId: string;
  imageDataUrl: string;
  expiresInSeconds: number;
}

export interface AuthResponse {
  token: string;
  /** Rolling session credential used to obtain a new seven-day access token. */
  refreshToken?: string;
  user: {
    id: string;
    email: string;
    phone: string | null;
    name: string;
    role: string;
  };
}

export interface JwtPayload {
  userId: string;
  email: string;
  phone?: string | null;
  role: string;
  iat?: number;
  exp?: number;
}

// 用户响应类型（不包含敏感信息）
export interface UserResponse {
  id: string;
  username: string;
  email: string;
  phone: string | null;
  name: string;
  organizationName: string | null;
  phoneVerifiedAt: Date | null;
  lastLoginAt: Date | null;
  lastActiveAt: Date | null;
  role: UserRole;
  userRoleId: string | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  createdBy: string | null;
  updatedBy: string | null;
}
